"use client";

import { useEffect } from "react";
import type { Adapter } from "../adapters/types";
import { events } from "./store";

interface Props {
  adapters?: Adapter[];
}

export const EventSubscription = ({ adapters = [] }: Props) => {
  useEffect(() => {
    adapters.forEach((adapter) => {
      adapter.load?.();
    });

    const unsubscribe = events.subscribe((event) => {
      adapters.forEach((adapter) => {
        adapter.consume(event);
      });
    });

    return () => {
      unsubscribe();
    };
  }, [adapters]);

  return null;
};

export class CustomAdapter implements Adapter {
  consume: Adapter["consume"];
  constructor(consume: Adapter["consume"]) {
    this.consume = consume;
  }
}
